/* Article mobile shop bar (sections/article-template.liquid).
   Shows after 25% scroll, hides while the related-products module is on screen,
   dismissible for the session. While visible it sets body.gs-shopbar-on, which
   lifts #gs-chat-bubble above the bar (gs-article-commerce.css).
   Keep this file free of template literals: the theme has been bitten by stray
   backticks in inline JS before. */
(function () {
  var bar = document.querySelector('[data-gs-shopbar]');
  if (!bar) return;
  var KEY = 'gs_shopbar_dismissed';
  try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}

  var mq = window.matchMedia('(max-width: 749px)');
  var moduleEl = document.querySelector('.gs-article-related-products');
  var moduleInView = false;
  var dismissed = false;
  bar.removeAttribute('hidden');

  function scrolledPast() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    return max > 0 && (window.scrollY || doc.scrollTop) / max >= 0.25;
  }

  function update() {
    var show = !dismissed && mq.matches && !moduleInView && scrolledPast();
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('gs-shopbar-on', show);
  }

  if (moduleEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      moduleInView = entries[0].isIntersecting;
      update();
    }, { threshold: 0.15 }).observe(moduleEl);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; update(); });
  }, { passive: true });
  window.addEventListener('resize', update);

  var close = bar.querySelector('[data-gs-shopbar-close]');
  if (close) {
    close.addEventListener('click', function () {
      dismissed = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      update();
    });
  }

  update();
})();
